import React from "react";
import ContactUs from "../Components/ContactUs/ContactUs";


const Contact = () => {
  return (
    <>
      <ContactUs />
     
      {/* Your remaining About Page sections here */}
    </>
  );
};

export default Contact;
